import store from '~/store'

export default (to, from, next) => {
  const user = store.getters['auth/user'];

  if (user.role.title !== 'administrator') {
    next({ name: 'settings', params: { id: user.id } })
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./resources/js/middleware/admin.js